import { BrowserRouter, Routes, Route } from 'react-router-dom';

import MainCardCarousel from './pages/MainCardCarousel'
import HorizontalBarCarousel from './pages/HorizontalBarCarousel';
import PopupSquareCarousel from './pages/PopupSquareCarousel';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainCardCarousel />} />
        <Route path="main-card" exact element={<MainCardCarousel />} />
        <Route path="horizontal-bar" exact element={<HorizontalBarCarousel />} />
        <Route path="popup-square" exact element={<PopupSquareCarousel />} />
        <Route path="*" element={<MainCardCarousel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
